import {WodCat, WodDescription} from "./types";

const wod1Scale: WodDescription = {
    title: "Event 1: Double Hang (Scale)",
    subtitle: "Teams of 2 | For Time | Cap 15 min",
    items: [
        ".27 Knee Raises Synchro",
        ".27 Hang DB Snatch Synchro @35/20",
        ".27/21 Cal Echo Bike --Each on their own Bike--",
        "<space>",
        ".21 Knee Raises Synchro",
        ".21 Burpee Box Step-Overs (or Box Jump Overs) Synchro 24/20",
        ".21/15 Cal Echo Bike --Each on their own Bike--",
        "<space>",
        ".15 Knee Raises Synchro",
        ".15 DB Thrusters Synchro 2x @35/20",
        ".15/12 Cal Echo Bike --Each on their own Bike--",
    ],
    category: WodCat.SCALE,
    footer: ""
}

const wod1RX: WodDescription = {
    title: "Event 1: Double Hang (RX)",
    subtitle: "Teams of 2 | For Time | Cap 15 min",
    items: [
        ".T2B Synchro Synchro",
        ".27 Hang DB Snatch Synchro @50/35",
        ".27/21 Cal Echo Bike --Each on their own Bike--",
        "<space>",
        ".21 T2B Synchro",
        ".21 Burpee Box Jump Overs Synchro 24/20",
        ".21/15 Cal Echo Bike --Each on their own Bike--",
        "<space>",
        ".15 T2B Synchro",
        ".15 DB Thrusters Synchro 2x @50/35",
        ".15/12 Cal Echo Bike --Each on their own Bike--",
    ],
    category: WodCat.RX,
    footer: ""
}


const wod2Scale: WodDescription = {
    title: "Event 2: Clean Assault (Scale)",
    subtitle: "Teams of 2 | For Time | Cap: 6 min per athlete",
    items: [
        "<b>Female Athlete completes:",
        ".10 Cleans @ 55",
        ".8 Cleans @ 65",
        ".6 Cleans @ 85",
        ".4 Cleans @ 95",
        ".2 Cleans @ 105",
        ".1 Clean @ 115",
        "<space>",
        "--Rest 3 min--",
        "<space>",
        "<b>Male Athlete completes:",
        ".10 Cleans @ 75",
        ".8 Cleans @ 95",
        ".6 Cleans @ 115",
        ".4 Cleans @ 135",
        ".2 Cleans @ 155",
        ".1 Clean @ 165",

    ],
    category: WodCat.SCALE,
    footer: ""
}


const wod2RX: WodDescription = {
    title: "Event 2: Clean Assault (RX)",
    subtitle: "Teams of 2 | For Time | Cap: 6 min per athlete",
    items: [
        "<b>Female Athlete completes:",
        ".10 Cleans @ 85",
        ".8 Cleans @ 105",
        ".6 Cleans @ 115",
        ".4 Cleans @ 125",
        ".2 Cleans @ 145",
        ".1 Clean @ 155",
        "<space>",
        "--Rest 3 min--",
        "<space>",
        "<b>Male Athlete completes:",
        ".10 Cleans @ 135",
        ".8 Cleans @ 155",
        ".6 Cleans @ 165",
        ".4 Cleans @ 185",
        ".2 Cleans @ 205",
        ".1 Clean @ 225",

    ],
    category: WodCat.RX,
    footer: ""
}

const wod31Scale: WodDescription = {
    title: "Event 3.1: Skill Test (Scale)",
    subtitle: "",
    items: [
        "<b>Athlete A: 2 Attempts",
        ".Max Wall-Supported Handstand Hold",
        "Rest 1min beween attempts",
        "<space>",
        "1min Transition",
        "<h3>Then",
        "<space>",
        "<b>Athlete B: 1 Attempt ",
        ".Max Dead Hang from Pull-Up Bar"
    ],
    category: WodCat.SCALE,
    footer: ""
}

const wod31Rx: WodDescription = {
    title: "Event 3.1: Skill Test (RX)",
    subtitle: "",
    items: [
        "<b>Athlete A: 2 Attempts",
        ".Max Freestanding Handstand Hold",
        "Rest 1min beween attempts",
        "<space>",
        "1min Transition",
        "<h3>Then",
        "<space>",
        "<b>Athlete B: 1 Attempt ",
        ".Max Wall-Supported Handstand Hold"
    ],
    category: WodCat.RX,
    footer: ""
}

const wod32Scale: WodDescription = {
    title: "Event 3.2: Boxes, Walls and Ropes (Scale)",
    subtitle: "Teams of 2 | AMRAP 6 minutes",
    items: [
        ".2 Wall-Walks",
        ".25 Single-Unders",
        "<space>",
        ".4 Wall-Walks",
        ".50 Single-Unders",
        "<space>",
        ".6 Wall-Walks",
        ".75 Single-Unders",
        "<space>",
        ".8 Wall-Walks",
        ".100 Single-Unders",

    ],
    category: WodCat.SCALE,
    footer: "Continue increasing by +2 Wall-Walks and +25 SUs each round"
}

const wod32Rx: WodDescription = {
    title: "Event 3.2: Boxes, Walls and Ropes (RX)",
    subtitle: "Teams of 2 | AMRAP 6 minutes",
    items: [
        ".2 Wall-Walks",
        ".25 Double-Unders",
        "<space>",
        ".4 Wall-Walks",
        ".50 Double-Unders",
        "<space>",
        ".6 Wall-Walks",
        ".75 Double-Unders",
        "<space>",
        ".8 Wall-Walks",
        ".100 Double-Unders",

    ],
    category: WodCat.RX,
    footer: "Continue increasing by +2 Wall-Walks and +25 DUs each round"
}

const finalRx: WodDescription = {
    title: "Final Event: ASCENSION (RX)",
    subtitle: "Teams of 2 | For Time | Cap: 13 minutes",
    items: [
        ".21 Synchro Pull-Ups",
        ".30 Cal Ski-Erg",
        ".21 Synchro Back Squats @ 135/95 lb",
        "<space>",
        ".18 Synchro Chest-to-Bar Pull-Ups",
        ".30 Cal Ski-Erg",
        ".18 Synchro Front Squats @ 135/95 lb",
        "<space>",
        ".12 Synchro Bar Muscle-Ups with Ring MU",
        ".30 Cal Ski-Erg",
        ".12 Synchro Overhead Squats @ 135/95 lb",

    ],
    category: WodCat.RX,
    footer: "Score: Time to complete all work"
}

const scaleRx: WodDescription = {
    title: "Final Event: ASCENSION (Scale)",
    subtitle: "Teams of 2 | For Time | Cap: 13 minutes",
    items: [
        ".21 Pull-Ups Synchro with Ring Rows",
        ".30 Cal Ski-Erg",
        ".21 Synchro Back Squats @ -",
        "<space>",
        ".18 Chest-to-Bar Synchro with Jumping Chest to Bar",
        ".30 Cal Ski-Erg",
        ".18 Synchro Front Squats @ -",
        "<space>",
        ".12 Bar Muscle-Ups Synchro with Jumping Bar Muscle-Ups",
        ".30 Cal Ski-Erg",
        ".12 Synchro Overhead Squats @ -",

    ],
    category: WodCat.SCALE,
    footer: "Score: Time to complete all work"
}

const getWorhouts = () => [
    wod1Scale,
    wod1RX,
    wod2Scale,
    wod2RX,
    wod31Scale,
    wod31Rx,
    wod32Scale,
    wod32Rx,
    finalRx,
    scaleRx
]

export {getWorhouts}